import styled from 'styled-components'

export const ModalComponent = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  // align-items: center;
  background-color: rgba(0,0,0,.6);
  backdrop-filter: blur(4px);
  z-index: 999;
  opacity: 1;
`

export const Content = styled.div`
  margin: 10px auto;
  background-color: white;
  padding: 1.5rem;
  border-radius: 8px;
  width: 100%;
  height: fit-content;

  @media (min-width: 360px) {
    width: 480px;
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`

export const Title = styled.h2`
  color: ${({ theme }) => theme.modalTextColor};
  width: 100%;
  font-size: 1.5em;
  text-align: center;
  margin-bottom: 1rem;
`

export const Body = styled.div`

`

export const Close = styled.i`
  font-size: 1.5em;
  cursor: pointer;
`

export const Hr = styled.hr`
  border: 0;
  border-top: 1px solid ${({ theme }) => theme.modalBorderColor};
  margin: 16px 0;
`
